import { render, staticRenderFns } from "./calendars.vue?vue&type=template&id=6980ba3e&"
import script from "./calendars.vue?vue&type=script&lang=js&"
export * from "./calendars.vue?vue&type=script&lang=js&"
import style0 from "./calendars.vue?vue&type=style&index=0&id=6980ba3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports